import { forwardRef, type TextareaHTMLAttributes } from 'react';

interface DsTextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /**
   * Render the typed text in `var(--font-mono)`. Reserve for code-style
   * payloads — JSON, XML, regex blocks. Prose fields stay on the default UI
   * font.
   */
  mono?: boolean;
}

/**
 * Multiline text input matching `DsInput` styling. Defaults to `rows={3}` and
 * vertical resize. Use page-specific CSS classes via the `className` prop only
 * for sizing overrides (`min-height`, `max-height`, `resize`, `flex`) — never
 * to restore padding, font or border, which the `.ds-textarea` rule owns.
 *
 * Forwards refs so chat-style autosize (`textarea.scrollHeight`) can attach.
 */
export const DsTextarea = forwardRef<HTMLTextAreaElement, DsTextareaProps>(
  ({ className = '', rows = 3, mono = false, ...props }, ref) => {
    const cls = ['ds-textarea', mono && 'is-mono', className]
      .filter(Boolean)
      .join(' ');
    return <textarea ref={ref} rows={rows} className={cls} {...props} />;
  },
);
